// extracted by mini-css-extract-plugin
module.exports = {"link":"desktopNavMenuItem_link__o3JA9","title":"desktopNavMenuItem_title__sQIiz","badgeText":"desktopNavMenuItem_badgeText__m31OT","desc":"desktopNavMenuItem_desc__bLs2v"};